import langJson from './lang.json';

export function getLangData(langCode?: string): LangData {

    if (langCode === undefined) langCode = window.location.pathname.split('/')[1];

    const keys = Object.keys(langJson);
    if (keys.includes(langCode)) {
        return matchLangCodeToJson(langJson, langCode);
    } else {
        return matchLangCodeToJson(langJson, "en");
    }
};

function matchLangCodeToJson(json: { [key: string]: LangData; }, langCode: string): LangData {
    return json[langCode];
}

export function getElementFrom(json: { [key: string]: string; }, key: string): string {
    return json[replaceSpaceByCamelCase(key)];
}

function replaceSpaceByCamelCase(input: string): string {
    input = input.trim();
    while (input.includes(' ')) {
        const index: number = input.indexOf(' ');
        const afterIndex = input.charAt(index + 1);
        input = input.substring(0, index) + afterIndex.toUpperCase() + input.substring(index + 2);
    }
    return input;
}

export function createLink(linkPath: string): string {

    const langCode = window.location.pathname.split('/')[1];
    if (langCode === undefined || langCode === '' || !getLangCodes().includes(langCode)) {
        return '/en' + linkPath;
    } else {
        return '/' + langCode + linkPath;
    }
}

export function getLangCodes() {
    return Object.keys(langJson);
}

export function getCurrentLangCode() {
    let currLangCode = window.location.pathname.split('/')[1].toLowerCase();
    if (getLangCodes().includes(currLangCode)) return currLangCode;
    return 'en';
}

interface LangData {

    meta: {
        apply: string;
        isLoading: string;
        clearAll: string;
        hqImg: string;
        imgFailedToLoad: string;
        imprintEnd: string;
        menu: string;
        noArtworksFound: string;
        noImgAvailable: string;
        on: string;
        pageNotFound: string;
        results: string;
    };

    news: {
        header: string;
    };

    biography: {
        header: string;
        mainText: string;
    };

    catalogue: {
        artworks: string;
        header: string;
        search: string;
        searchPlaceholder: string;
        searchHint: string;
        results: string;
        loadMore: string;
        filter: string;
        typeOfObject: string;
        typeOfObjectValues: {
            painting: string;
            collage: string;
            drawing: string;
            print: string;
            book: string;
            newspaperClipping: string;
            pamphlet: string;
            paper: string;
            photocopy: string;
            photograph: string;
            postcard: string;
            puppets: string;
            sketchbook: string;
            writing: string;
        };
        keywords: string;
        keywordsValues: {
            figurative: string;
            portrait: string;
            stillLife: string;
            landscape: string;
            text: string;
            abstract: string;
        };
        material: string;
        materialValues: {
            oil: string;
            pencil: string;
            pen: string;
            charcoal: string;
            gouache: string;
            watercolour: string;
            pastel: string;
            ink: string;
            eggTempera: string;
            paper: string;
            organicMatter: string;
        };
        support: string,
        supportValues: {
            canvas: string;
            board: string;
            paper: string;
            glass: string;
        };
        measurements: string;
        date: string;
        height: string,
        width: string,
        sortBy: string,
        sortingValues: {
            editorsChoice: string,
            newestToOldest: string,
            oldestToNewest: string;
        };
    };

    estate: {
        header: string;
        content: string;
    };

    contact: {
        header: string;
        header2: string;
        fillOut: string;
        name: string;
        enterName: string;
        email: string;
        enterEmail: string;
        emailHint: string;
        subject: string;
        enterSubject: string;
        message: string;
        enterMessage: string;
        send: string;
        success: string;
        failed: string;
        missingName: string;
        missingEmail: string;
        missingSubject: string;
        missingMessage: string;
        missingRecaptcha: string;
    };

    imprint: {
        header: string;
        executor: string;
        coordinators: string;
        designWebsite: string;
        imgHomePage: string;
    };

}